import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { ArrowLeft } from 'lucide-react';

const MentionsLegalesPage = () => {
  return (
    <div className="min-h-screen" style={{ backgroundColor: '#E9DFCF' }} data-testid="mentions-legales-page">
      <Header />
      
      <main className="py-16 md:py-24">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/" className="inline-flex items-center text-gray-600 hover:text-gray-900 mb-8">
            <ArrowLeft className="w-5 h-5 mr-2" />
            Retour à l'accueil
          </Link>

          <div className="bg-white rounded-2xl p-8 md:p-12 shadow-sm border border-gray-200">
            <h1 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-8" style={{ letterSpacing: '-0.04em' }}>
              Mentions légales
            </h1>

            <div className="prose prose-gray max-w-none">
              <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">1. Informations légales</h2>
              
              <h3 className="text-lg font-semibold text-gray-900 mt-6 mb-3">Éditeur du site</h3>
              <p className="text-gray-600 mb-4">
                <strong>Raison sociale :</strong> ACDC-Formation<br />
                <strong>Adresse :</strong> 7 avenue Paul Cézanne, 83600 Cogolin<br />
                <strong>Téléphone :</strong> 06 78 26 91 10 / 07 69 05 76 73<br />
                <strong>Email :</strong> contact@acdc-formation.com<br />
                <strong>Site web :</strong> [acdc-formation.com / formactionpro.net]
              </p>

              <h3 className="text-lg font-semibold text-gray-900 mt-6 mb-3">Responsable de publication</h3>
              <p className="text-gray-600 mb-4">
                [David Contal / François Schoonheere]
              </p>

              <h3 className="text-lg font-semibold text-gray-900 mt-6 mb-3">Hébergeur</h3>
              <p className="text-gray-600 mb-4">
                <strong>Nom :</strong> [Vercel]<br />
                <strong>Adresse :</strong> Vercel Inc., 340 S Lemon Ave #4133, Walnut, CA 91789, USA<br />
                <strong>Site web :</strong> https://vercel.com
              </p>

              <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">2. Activité</h2>
              <p className="text-gray-600 mb-4">
                ACDC-Formation est un organisme de formation professionnelle spécialisé dans :
              </p>
              <ul className="list-disc pl-6 text-gray-600 mb-4">
                <li>L'IA générative et l'automatisation pour les entreprises</li>
                <li>Le management et le leadership</li>
                <li>Les soft skills et l'intelligence relationnelle</li>
                <li>Le digital et la création web</li>
              </ul>

              <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">3. Propriété intellectuelle</h2>
              <p className="text-gray-600 mb-4">
                L'ensemble du contenu de ce site (textes, images, vidéos, logos, marques) est protégé 
                par le droit de la propriété intellectuelle. Toute reproduction, représentation, 
                modification, publication, adaptation de tout ou partie des éléments du site est 
                interdite sans autorisation écrite préalable de ACDC-Formation.
              </p>

              <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">4. Données personnelles</h2>
              <p className="text-gray-600 mb-4">
                Les informations collectées via les formulaires de ce site sont destinées à 
                ACDC-Formation pour le traitement de vos demandes. Conformément au RGPD, 
                vous disposez d'un droit d'accès, de rectification, de suppression et de portabilité 
                de vos données. Pour exercer ces droits, contactez-nous à contact@acdc-formation.com.
              </p>
              <p className="text-gray-600 mb-4">
                Pour plus d'informations, consultez notre{' '}
                <Link to="/confidentialite" className="text-blue-700 hover:underline">
                  politique de confidentialité
                </Link>.
              </p>

              <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">5. Cookies</h2>
              <p className="text-gray-600 mb-4">
                Ce site utilise des cookies pour améliorer l'expérience utilisateur et analyser 
                le trafic. Vous pouvez gérer vos préférences via la bannière de consentement 
                qui s'affiche lors de votre première visite.
              </p>

              <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">6. Limitation de responsabilité</h2>
              <p className="text-gray-600 mb-4">
                ACDC-Formation s'efforce d'assurer l'exactitude des informations diffusées sur 
                ce site, mais ne peut être tenu responsable des erreurs, omissions ou résultats 
                qui pourraient être obtenus par un mauvais usage de ces informations.
              </p>

              <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">7. Droit applicable</h2>
              <p className="text-gray-600 mb-4">
                Les présentes mentions légales sont soumises au droit français. En cas de litige, 
                les tribunaux français seront seuls compétents.
              </p>

              <p className="text-gray-500 text-sm mt-8">
                Dernière mise à jour : Février 2026
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default MentionsLegalesPage;
